import { connect } from 'react-redux';

import RevenueMainOptionsBar from '../../components/revenue/RevenueMainOptionsBar';
import {
  setRevenueGroupColumn,
  setRevenueSplitColumn,
  setRevenueType,
  changeRevenueView,
  setAmountField,
} from '../../actions/revenue';
import {
  getMetainf,
  getRevenueAmountField,
  getRevenueAmountFields,
  getRevenueChartOptions,
  getRevenueGroupColumn,
  getRevenueQueryType,
  getRevenueSplitColumn,
} from '../../reducers/analyticsApp';
import { commonEvents } from '../../constants/event';
import { revenueQueryTypes } from '../../constants/revenue';

const mapStateToProps = (state) => ({
  metainf:
    getRevenueQueryType(state) === revenueQueryTypes.ARPU ||
    getRevenueQueryType(state) === revenueQueryTypes.PAYERS
      ? getMetainf(state)
      : getMetainf(state, commonEvents.PAYMENT),
  groupColumn: getRevenueGroupColumn(state),
  splitColumn: getRevenueSplitColumn(state),
  view: getRevenueChartOptions(state).view,
  viewOptions: getRevenueChartOptions(state).views,
  queryType: getRevenueQueryType(state),
  field: getRevenueAmountField(state),
  fields: getRevenueAmountFields(state),
});

const mapDispatchToProps = (dispatch) => ({
  onChangeGroupColumn: (value) => dispatch(setRevenueGroupColumn(value)),
  onChangeSplitColumn: (value) => dispatch(setRevenueSplitColumn(value)),
  onChangeQueryType: (value) => dispatch(setRevenueType(value)),
  onChangeView: (value) => dispatch(changeRevenueView(value)),
  onChangeAmount: (value) => dispatch(setAmountField(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RevenueMainOptionsBar);
